import { createAsyncThunk } from '@reduxjs/toolkit';
import { UpdatePropertyRequest } from '../../types/accommodation';
import * as accommodationService from '../../services/accommodationService';

// Read-only: resolves null when the outlet has no property yet. Properties
// are only created explicitly from Settings → Properties (createPropertyThunk),
// never as a side effect of opening an accommodation page.
export const fetchPropertyThunk = createAsyncThunk(
  'accommodation/fetchProperty',
  async (outletId: string, { rejectWithValue }) => {
    try {
      return await accommodationService.fetchProperty(outletId);
    } catch (e) {
      return rejectWithValue(
        e instanceof Error ? e.message : 'Failed to load property',
      );
    }
  },
);

export const createPropertyThunk = createAsyncThunk(
  'accommodation/createProperty',
  async (args: { outletId: string; name: string }, { rejectWithValue }) => {
    try {
      return await accommodationService.createProperty(
        args.outletId,
        args.name,
      );
    } catch (e) {
      return rejectWithValue(
        e instanceof Error ? e.message : 'Failed to create property',
      );
    }
  },
);

export const updatePropertyThunk = createAsyncThunk(
  'accommodation/updateProperty',
  async (
    args: { id: string; updates: UpdatePropertyRequest },
    { rejectWithValue },
  ) => {
    try {
      return await accommodationService.updateProperty(args.id, args.updates);
    } catch (e) {
      return rejectWithValue(
        e instanceof Error ? e.message : 'Failed to update property',
      );
    }
  },
);

export const fetchAllCompanyPropertiesThunk = createAsyncThunk(
  'accommodation/fetchAllCompanyProperties',
  async (_, { rejectWithValue }) => {
    try {
      return await accommodationService.fetchAllCompanyProperties();
    } catch (e) {
      return rejectWithValue(
        e instanceof Error ? e.message : 'Failed to fetch properties',
      );
    }
  },
);
